__turbopack_context__.v({
  "bestCard": "PlanCard-module-scss-module__he56Da__bestCard",
  "bestValueLabel": "PlanCard-module-scss-module__he56Da__bestValueLabel",
  "card": "PlanCard-module-scss-module__he56Da__card",
  "cta": "PlanCard-module-scss-module__he56Da__cta",
  "initialPrice": "PlanCard-module-scss-module__he56Da__initialPrice",
  "initialPriceMonth": "PlanCard-module-scss-module__he56Da__initialPriceMonth",
  "price": "PlanCard-module-scss-module__he56Da__price",
  "priceDisclaimer": "PlanCard-module-scss-module__he56Da__priceDisclaimer",
  "priceDisclaimerWithTrial": "PlanCard-module-scss-module__he56Da__priceDisclaimerWithTrial",
  "title": "PlanCard-module-scss-module__he56Da__title",
});
